module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-25-eb6156c0ec9c829985c1b0a6e1ff2bc1.jpg";